<template>
  <v-dialog max-width="250px" v-model="dialog" @keydown.enter.prevent="close">
    <v-card>
      <v-card-title>
        <span class="headline">Worker</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <r-worker-kind label="Worker kind:" :model.sync="value.kind" :skip-none="skipNone"/>
          </v-col>
          <v-col cols="12">
            <v-text-field label="Worker level:" v-model.number="value.level" hide-details/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
    <template v-slot:activator="{ on }">
      <v-text-field
          v-model.trim="label"
          label="Worker:"
          readonly
          v-on="on"
          clearable
          @click:clear="clear"
      />
    </template>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {WorkerKey} from "@/modules/redactor/models/worker/WorkerKey";
import {WorkerKind} from "@/modules/redactor/models/worker/WorkerKind";
import RWorkerKind from "@/modules/redactor/views/worker/r-worker-kind";

export default {
  name: "r-worker-key",
  components: {RWorkerKind},
  props: {
    model: VueTypes.instanceOf(WorkerKey),
    skipNone: VueTypes.bool.def(false)
  },
  data: () => ({
    dialog: false,
    label: null
  }),
  methods: {
    checkChange() {
      if(this.value.kind){
        if (WorkerKind.isNone(this.value.kind)) {
          this.label = "";
        } else {
          this.label = this.value.kind.name + " (" + this.value.level + ")";
        }
      }
    },
    close(){
      this.dialog = false
    },
    clear() {
      this.$emit("update:model", null);
    }
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new WorkerKey();
        this.$emit("update:model", value);
        return value;
      }
    }
  },
  mounted() {
    this.checkChange()
  },
  watch: {
    dialog() {
      this.checkChange();
    },
    value() {
      this.checkChange();
    }
  },
}
</script>
